import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import { TICKET_DETAILS, REPLIED_ON_TICKET, STATUS_LIST, CHANGE_STATUS } from "./type";

export const getTicketDetails = (ticketId) => async (dispatch) => {
  try {
    dispatch({
      type: TICKET_DETAILS,
      payload: null,
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.tickets.getTicketDetails}${ticketId}`
    );
      // console.log(res); return false;
    if (res) {
      const { data } = res;
      dispatch({
        type: TICKET_DETAILS,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: TICKET_DETAILS,
      payload: null,
    });
    return true;
  }
};

export const repliesOnTicket = (obj) => async (dispatch) => {
  const object = {
    "ticket_id": obj.ticketId,
    "message": obj.responseText,
    "attatchment": obj.document
  };
  const res = await callWebService(
    callTypes.post,
    object,
    `${Config.tickets.replyOnTicket}`
  );
  
  if (res) {
    const { data } = res;
    dispatch({
      type: REPLIED_ON_TICKET,
      payload: data.response.data,
    });
    return true;
  }
}

export const getStatusList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.tickets.statusList}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: STATUS_LIST,
      payload: data.response.data,
    });
    return true;
  }
}

export const changeStatus = (ticketId, newStatus) => async (dispatch) => {
  const object = {
    "ticket_id": ticketId,
    "status_id": newStatus.value,
  };
  const res = await callWebService(
    callTypes.put,
    object,
    `${Config.tickets.updateStatus}?ticket_id=${ticketId}&status=${newStatus.id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CHANGE_STATUS,
      payload: data.response.data,
    });
    return true;
  }
}